import { Link, useSearchParams } from "react-router-dom";
import { Dropdown, DropdownItem } from "../common/Dropdown";
import { getRoundSelectionParamsFromUrlParams } from "./hooks/useFilterRounds";
import { toQueryString } from "./RoundsFilter";
import { getSortLabel } from "./utils/getSortLabel";
import { jsx as _jsx } from "react/jsx-runtime";
export const SORT_OPTIONS = [{
  label: "All",
  orderBy: "NATURAL"
}, {
  label: "Newest",
  orderBy: "CREATED_AT_BLOCK_DESC"
}, {
  label: "Oldest",
  orderBy: "CREATED_AT_BLOCK_ASC"
}, {
  label: "Round end (earliest)",
  orderBy: "DONATIONS_END_TIME_ASC"
}, {
  label: "Round end (latest)",
  orderBy: "DONATIONS_END_TIME_DESC"
} /*
  {
  label: "Highest contributor count",
  orderBy: "<unknown>",
  orderDirection: "asc",
  },
  {
  label: "Lowest contributor count",
  orderBy: "<unknown>",
  orderDirection: "desc",
  },
  {
  label: "Highest project count",
  orderBy: "projects",
  orderDirection: "asc",
  },
  {
  label: "Lowest project count",
  orderBy: "projects",
  orderDirection: "desc",
  },*/, {
  label: "Matching funds: high to low",
  orderBy: "MATCH_AMOUNT_IN_USD_DESC"
}, {
  label: "Matching funds: low to high",
  orderBy: "MATCH_AMOUNT_IN_USD_ASC"
}];
export function SortDropdown() {
  const [params] = useSearchParams();
  const {
    orderBy
  } = getRoundSelectionParamsFromUrlParams(params);
  const selected = getSortLabel({
    orderBy
  });
  return /*#__PURE__*/_jsx(Dropdown, {
    label: selected === null || selected === void 0 ? void 0 : selected.label,
    options: SORT_OPTIONS,
    renderItem: _ref => {
      let {
        label,
        orderBy,
        close
      } = _ref;
      return /*#__PURE__*/_jsx(DropdownItem, {
        $as: Link
        // Merge search params
        ,
        to: `/rounds?${toQueryString({
          ...Object.fromEntries(params),
          orderBy
        })}`,
        preventScrollReset: true,
        onClick: close,
        children: label
      });
    }
  });
}